<template>
  <div>
    <div class="search_cond">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="dialogState = true"
        class="ml20 mt10 searchBtn"
        >新增</el-button
      >
    </div>

    <rv-table
      ref="rvTable"
      :tableData="tableData"
      :totalNum="totalNum"
      :isLoading="isLoading"
      :treeProps="treeProps"
      rowKey="menuId"
      @getData="getData"
    >
      <!-- <el-table-column label="序号" width="50">
        <template #default="scoped">
          <span v-if="scoped.row.isIndex">{{ scoped.row.parentIndex }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="菜单名称" prop="menuName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="菜单地址"
        show-overflow-tooltip
        prop="component"
      />
      <el-table-column label="路由地址" show-overflow-tooltip prop="path" />
      <el-table-column label="操作" prop="carColour" fixed="right" width="160">
        <template #default="scoped">
          <el-button type="text" @click="updateData(scoped.row)"
            >修改</el-button
          >
          <el-button type="text" @click="deleteData(scoped.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </rv-table>

    <!-- 添加菜单弹窗 -->
    <add-menu @close="closeDialog" v-if="dialogState" ref="addMenu" />
  </div>
</template>
<script>
import addMenu from "./components/addMenu";
import { menuQueryPage, menuDelete } from "@/api/system/menu";
export default {
  data() {
    return {
      tableData: [],
      totalNum: 0,
      isLoading: false,
      dialogState: false,
      treeProps: { children: "sysMenus" },
    };
  },
  components: {
    addMenu,
  },
  mounted() {
    this.$refs.rvTable.initData();
  },
  methods: {
    // 获取列表
    getData(options) {
      this.isLoading = true;
      menuQueryPage({
        pageNum: options.pageNum,
        pageSize: options.pageSize,
      })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.result.list;
            this.totalNum = res.result.total;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //修改数据
    updateData(e) {
      this.dialogState = true;
      this.$nextTick(() => {
        this.$refs.addMenu.initData(e);
      });
    },
    // 删除列表
    deleteData(e) {
      this.$confirm("是否要执行此操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        menuDelete({ id: e.menuId }).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.$refs.rvTable.initData();
          }
        });
      });
    },
    closeDialog(e) {
      if (e) {
        this.$refs.rvTable.initData();
      }
      this.dialogState = false;
    },
  },
};
</script>
<style scoped>
.data_wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.handle-input {
  width: 150px;
  display: inline-block;
}
.handle-select {
  width: 120px;
}
.searchBtn {
  height: 30px;
  background: #3b7bcf;
}
.etype {
  font-weight: bold;
  color: #212121;
}
.verticalCol {
  display: flex;
  flex-direction: column;
}
.myDrawer {
  width: 60%;
}
.dialog_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  color: #fff;
}
.btnOnline {
  color: #3b7bcf;
}
.btnOutLine {
  color: #8c939d;
}
.equipList {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.equipList span {
  color: #666666;
  font-size: 16px;
}
</style>
<style less>
</style>
